import { allRoutes, routeName } from '@/router';

function handleAddRouters(roleTree) {
  const showRoutes = [];

  if (!roleTree || roleTree.length === 0) {
    return showRoutes;
  }

  showRoutes.push(allRoutes[routeName.dashboard]);

  roleTree.forEach(element => {
    if (element.router) {
      const children = [];
      const route = Object.assign({}, allRoutes[element.router]);

      if (element.sons) {
        element.sons.map(item => {
          if (item.router) {
            children.push(allRoutes[item.router]);
          }
        });
      }

      route.children = children;
      showRoutes.push(route);
    }
  });

  return showRoutes;
}

const asyncRouter = {
  namespaced: true,

  state: {
    // 权限菜单
    tree: [],
  },

  getters: {
    // 路由菜单
    menus(state) {
      return handleAddRouters(state.tree);
    },

    menusIsReady(state, getters) {
      return !!getters.menus.length;
    },
  },

  mutations: {
    setTree(state, value) {
      state.tree = value;
    },
  },

  actions: {
    // 获取权限菜单
    getTree({ commit }) {
      let list = [
        {
          id: 1,
          name: '订单管理',
          router: routeName.order,
          sons: [
            {
              id: 2,
              name: '订单列表',
              router: routeName.orderList,
            },
          ],
        },
        {
          id: 3,
          name: '用户管理',
          router: routeName.member,
          sons: [
            {
              id: 4,
              name: '用户列表',
              router: routeName.memberList,
            },
          ],
        },
        {
          id: 5,
          name: '系统设置',
          router: 'Setting',
          sons: [
            {
              id: 6,
              name: '线路价格',
              router: routeName.serviceList,
            },
            {
              id: 11,
              name: '线路价格',
              router: routeName.serviceGoodsCate,
            },
            {
              id: 7,
              name: '成员列表',
              router: routeName.settingMember,
            },
            {
              id: 8,
              name: '管理权限',
              router: routeName.settingAuthority,
            },
            {
              id: 9,
              name: '文案设置',
              router: routeName.articleSetting,
            },
            {
              id: 10,
              name: '公司信息设置',
              router: routeName.companySetting,
            },
          ],
        },
      ];
      commit('setTree', list);
      return list;
    },
  },
};

export default asyncRouter;
